import { getBarleyPackage, updateBarleyPackage } from './Barley/Barley'
import { getBreadPackage, updateBreadPackage } from './Bread/Bread'
import {
  getBrownRicePackage,
  updateBrownRicePackage,
} from './BrownRice/BrownRice'
import { getBulgurPackage, updateBulgurPackage } from './Bulgur/Bulgur'
import {
  getOatsOatmealPackage,
  updateOatsOatmealPackage,
} from './OatsOatmeal/OatsOatmeal'

export const getWholeGrainsPackage = subCategory => {
  switch (subCategory) {
    case '001':
      return getBreadPackage
    case '003':
      return getBrownRicePackage
    case '004':
      return getBulgurPackage
    case '005':
      return getOatsOatmealPackage
    case '006':
      return getBarleyPackage
    default:
      break
  }
}

export const updateWholeGrainsPackage = product => {
  switch (product.subCategory || product.fkSubCategory) {
    case '001':
      return updateBreadPackage(product)
    case '003':
      return updateBrownRicePackage(product)
    case '004':
      return updateBulgurPackage(product)
    case '005':
      return updateOatsOatmealPackage(product)
    case '006':
      return updateBarleyPackage(product)
    default:
      break
  }
}
